// extracted by mini-css-extract-plugin
export var backupIcon = "_oq-1";
export var image = "_oq-0";